<template>
  <div class="onsell">
    <div class="top_title fixed">正在出售</div>
    <sell-component :ItemName="detail.ItemName" :detail="detail" :type="2"/>
    <seamless-scroll :list1="baseEffect" :list2="NpProperty" v-if="baseEffect.length != 0 || NpProperty.length != 0"/>
    <div class="updown">
      <el-button class="pay_btn" type="primary" @click="changedown">免费下架</el-button>
      <!-- <el-button class="pay_btn" type="primary" >重新上架</el-button> -->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        detail: {},
        baseEffect: [],
        NpProperty: []
      };
    },
    computed: {
      goods_id() {
        return this.$route.query.id
      },
    },
    mounted() {
      this.getGoodsDetail()
    },

    methods: {
      getGoodsDetail() {
        this.$Ajax('goods/goods-detail', {goods_id:this.goods_id}, 'get').then(rs => {
          if (rs.code == 200) {
            this.detail = rs.data.detailInfo || {}
            this.detail.price = rs.data.price
            this.detail.num = rs.data.num
            this.detail.icon = rs.data.icon
            if(rs.data.detailInfo) {
              if(rs.data.detailInfo.ItemDes.baseEffect) {
                this.baseEffect = rs.data.detailInfo.ItemDes.baseEffect
              }
              if(rs.data.detailInfo.ItemDes.NpProperty) {
                this.NpProperty = rs.data.detailInfo.ItemDes.NpProperty
              }
            }
          } else {
            // if (this.$store.state.role_id == '' || this.$store.state.role_id == undefined) {
            //   this.$RModal.bindtips()
            // }
          }
        })
      },
      changedown() {
        this.$Ajax('goods/change-down', {
          goods_id: this.goods_id
        }).then(rs => {
          if (rs.code == 200) {
            this.$toast({
              message: rs.msg,
              duration: "2000",
              onClose: () => {
                this.$router.go(-1)
              }
            })
          }
        })
      },

    },
  };
</script>

<style lang="less" scoped>
  .onsell {
    .updown {
      width: 100%;
      height: 12rem;
      margin-top: 2.9rem;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .pay_btn {
        margin: 1rem auto;
        display: block;
        padding: 0;
        width: 11.5rem;
        height: 2.4rem;
        font-size: 1.2rem;
        border-radius: 10rem;
      }
    }
  }
</style>